<template>
    <ContainerLayout page="0">
        <template v-slot:navbar>
            <nav class="navbar navbar-expand navbar-light bg-white text-dark">
                <router-link :to="{ path: '', query: { ...$route.query } }" class="nav-link" @click.prevent="goBack">
                    <font-awesome-icon icon="arrow-left" class="text-dark" />
                </router-link>
                <div class="navbar-nav mr-auto">
                    <li class="nav-item">
                        <h6 class="nav-link mb-0 text-dark font-weight-bold">
                            {{ $route.meta.title }}
                        </h6>
                    </li>
                </div>
            </nav>
            <hr class="my-0" style="height: 1.5px;">
        </template>
        <div v-if="loaded_data" class="content px-1">
            <div v-if="!carts || carts.length == 0"
                class="d-flex flex-column justify-content-center align-items-center text-center">
                <img id="img-card" class="img-card" src="@/assets/images/logo-empty.png" />
                <label class="mt-4 mb-1 font-weight-bold">{{ $t('Your cart is empty!') }}</label>
                <label class="text-muted">{{ $t('Please add some products to your cart') }}</label>
            </div>
            <div v-else>
                <div class="row mx-0" style="margin-top: -20px;">
                    <div v-for="(data, branchId) in carts" :key="branchId" class="col-12 px-0 px-md-2">
                        <div class="my-2" style="background-color: white;">
                            <div class="d-flex align-items-center">
                                <div :id="'checkbox_branch_' + branchId" @click="toggleCheckboxBranch(branchId)"
                                    class="fake-checkbox">
                                    <font-awesome-icon
                                        :icon="['far', checkboxAllByBranch[branchId] ? 'check-square' : 'square']" />
                                </div>
                                <div class="d-flex flex-column">
                                    <small style="font-weight: 500; font-size: 12px;">
                                        {{ data.branch_data.name }} ({{ data.branch_data.brand }})
                                    </small>
                                    <small style="font-size: 12px;">
                                        {{ data.branch_data.current_location_name + ' - ' +
                                            (data.branch_data.location_airport_code ? data.branch_data.location_airport_code +
                                                ', ' : '') + data.branch_data.location_city + ', ' +
                                            data.branch_data.location_province }}
                                    </small>
                                </div>
                            </div>
                        </div>
                        <hr class="my-0 full-hr" style="border-top: 2px solid rgba(0,0,0,.1);">
                        <div v-for="(item, key) in data.grouped_carts" :key="key" class="col-12 px-0 px-md-2">
                            <div class="w-100 row mx-0 mt-3">
                                <div class="col-12 mb-3 pl-2 pr-0">
                                    <div class="h-100 card-container d-flex">
                                        <div class="mr-2">
                                            <div :id="'checkbox_item_' + item.id"
                                                @click="toggleCheckboxItem(item, branchId)" class="fake-checkbox">
                                                <font-awesome-icon
                                                    :icon="['far', selectedItems[item.id] ? 'check-square' : 'square']" />
                                            </div>
                                        </div>
                                        <div class="w-100 ml-auto">
                                            <div class="h-100 card" @click.prevent="toggleCheckboxItem(item, branchId)"
                                                style="border-radius: 0.25rem; box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2); display: flex; flex-direction: column; justify-content: space-between; cursor: pointer;"
                                                :style="selectedItems[item.id] ? ' border: 1.5px solid #275D93;' : ' border: 1.5px solid rgba(0,0,0,.125);'">
                                                <div class="my-2 mx-3 pb-2">
                                                    <div class="row">
                                                        <div class="col-9">
                                                            <div
                                                                class="d-flex flex-column justify-content-start align-items-start">
                                                                <small style="font-weight: 600;">{{
                                                                    item.product_detail.product.current_name
                                                                }}</small>
                                                                <small class="text-muted" style="font-size: 13px;">{{
                                                                    item.product_detail.product.product_category.name
                                                                }}</small>
                                                                <small class="text-main" style="font-weight: 700;">{{
                                                                    item.total_price_formatted
                                                                }}</small>
                                                                <div>
                                                                    <div class="badge badge-main mr-1">
                                                                        {{ item.product_detail.detail_label }}
                                                                    </div>
                                                                    <div v-if="item.cart_addons.length > 0"
                                                                        class="badge badge-outline badge-main mr-1">
                                                                        + {{ item.cart_addons.length }} {{
                                                                            item.cart_addons.length >
                                                                            1 ? $t('Bundles') : $t('Bundle') }}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-3">
                                                            <div
                                                                class="h-100 d-flex justify-content-end align-items-center">
                                                                <img :src="item.product_detail.product.image_url"
                                                                    style="width: 30px; height: auto;">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="card-footer p-1">
                                                    <div class="d-flex align-items-center p-2">
                                                        <div class="d-flex flex-column mb-1">
                                                            <small style="font-weight: 500; font-size: 10px;">{{
                                                                $t('Product by') }}
                                                                :</small>
                                                            <div class="d-flex align-items-center">
                                                                <img :src="item.product_detail.product.provider.image_url"
                                                                    class="img-fluid mr-1 d-md-block d-none"
                                                                    style="width: 25px; height: auto;">
                                                                <p class="mb-0" style="font-weight: 500; font-size: 10px;">
                                                                    {{
                                                                        item.product_detail.product.provider.name
                                                                    }}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div class="ml-auto d-flex align-items-center">
                                                            <button class="btn btn-outline-secondary btn-sm mr-1"
                                                                @click.stop="remove(item.id, branchId)">
                                                                <font-awesome-icon icon="trash" />
                                                            </button>
                                                            <button class="btn btn-outline-main btn-sm"
                                                                @click.stop="detail(item)">
                                                                {{ $t('Update') }}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr class="my-0 full-hr inside-row" style="border-top: 2px solid rgba(0,0,0,.1);">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="content px-1">
            <div class="row mx-0" style="margin-top: -20px;">
                <div v-for="( item, index ) in  [1, 2] " :key="index" class="col-12 px-0 px-md-2">
                    <div class="my-2 pt-1" style="background-color: white;">
                        <div class="skeleton-location" />
                    </div>
                    <hr class="my-0 full-hr" style="border-top: 2px solid rgba(0,0,0,.1);">
                    <div class="w-100 row mx-0 mt-3 pl-1">
                        <div class="col-12 mb-3 pl-2 pr-0">
                            <div :id="item" class="skeleton-card" />
                        </div>
                    </div>
                    <hr class="my-0 full-hr" style="border-top: 2px solid rgba(0,0,0,.1);">
                </div>
            </div>
        </div>
        <template v-slot:bottom-bar v-if="selectedCarts.length > 0">
            <div class="w-100 d-flex flex-column card-footer">
                <div class="w-100 d-flex justify-content-end align-items-center">
                    <div class="d-flex flex-column">
                        <small style="font-weight: 700;">
                            {{ $t('Total') }}
                        </small>
                        <small class="text-main" style="font-weight: 700; font-size: 15px;">
                            {{ total_selected_price_formatted }}
                        </small>
                    </div>
                    <div class="ml-auto">
                        <button class="btn btn-sm btn-main" @click.prevent="goToPayment()"
                            style="border-radius: 10px; width: 100px;">
                            {{ $t('Buy') }}
                        </button>
                    </div>
                </div>
            </div>
        </template>
        <vue-bottom-sheet ref="modalDetail" :swipeable="false" :rounded="true" max-height="80vh">
            <div id="modal-main" style="height: 80vh; max-height: 80vh;">
                <div v-if="product">
                    <div id="modal-body">
                        <div style="overflow-y: auto; height: 100%;">
                            <div class="w-100 d-flex justify-content-center align-items-center">
                                <div class="d-flex align-items-center"
                                    style="border-radius: 0px 0px 6px 6px; border: 2px solid rgba(0,0,0,.125); border-top: none; padding: 5px 15px;">
                                    <div class="rounded-circle bg-white d-flex justify-content-center align-items-center mr-2"
                                        style="min-width: 22px; min-height: 22px; border: 1px solid #275D93; padding: 2px;">
                                        <img :src="product.provider.image_url" class="img-fluid"
                                            style="width: 22px; height: auto; max-height: 22px;" />
                                    </div>
                                    <div class="d-flex flex-column">
                                        <small class="text-muted" style="font-weight: 500; font-size: 9px;">
                                            {{ $t('Product by') }}
                                        </small>
                                        <small style="font-weight: 500; font-size: 10px;">
                                            {{ product.provider.name }}
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div class="w-100 d-flex flex-column justify-content-start align-items-start px-4 py-3">
                                <small style="font-weight: 600; font-size: 15px;">{{ product.current_name }}</small>
                                <small class="text-main" style="font-weight: 500; font-size: 15px;">
                                    {{ selected_product_detail.price_formatted }}
                                </small>
                                <div v-if="product.show_detail_label">
                                    <div v-if="product.active_product_details.length > 1" class="mt-2">
                                        <small class="text-muted" style="font-weight: 500; font-size: 12px;">
                                            {{ $t('Choose') }} {{ $t(product.active_product_details[0].type) }}
                                        </small>
                                        <br>
                                    </div>
                                    <div v-for="( detail, index ) in  product.active_product_details " :key="index"
                                        :class="detail.detail_label == selected_product_detail.detail_label ? 'badge badge-main mr-2' : 'badge badge-outline badge-main mr-2'"
                                        :style="detail.detail_label == selected_product_detail.detail_label ? 'cursor: default; border: 1px solid #275D93;' : 'cursor: pointer;'"
                                        @click.prevent="selectProductDetail(detail)">
                                        {{ detail.detail_label }}
                                    </div>
                                </div>
                                <small v-if="modal_cart.api_response && modal_cart.api_response['data']" class="mt-4"
                                    style="font-weight: 500;">
                                    {{ $t('Information') }}
                                </small>
                                <div v-if="modal_cart.api_response_formatted" class="w-100" style="font-size: 12px;">
                                    <div v-for="( item, index ) in  modal_cart.api_response_formatted " :key="index"
                                        class="w-100 d-flex mb-1">
                                        <div>
                                            {{ $t(item['name']) }}
                                        </div>
                                        <div class="ml-auto text-right">
                                            {{ item['value'] }}
                                        </div>
                                    </div>
                                </div>
                                <small class="mt-4" style="font-weight: 500;">
                                    {{ $t('Description') }}
                                </small>
                                <small style="font-size: 12px;">
                                    {{ product.current_description ?? '-' }}
                                </small>
                                <div v-if="product.show_recommendation" class="mt-4 w-100">
                                    <small style="font-weight: 500;">
                                        {{ $t('Additional Bundles') }}
                                    </small>
                                    <div class="w-100 d-flex flex-row justify-content-start align-items-center mt-2"
                                        style="overflow-x: auto; overflow-y: hidden; white-space: nowrap;">
                                        <div v-for="( item, index ) in  product.product_addons " :key="index"
                                            class="card mr-2 mb-3 mt-1 h-100"
                                            style="width: 150px !important; flex-shrink: 0; min-height: 100px; border-radius: 0.25rem; box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.2);"
                                            :style="selected_product_addons.find(addon => addon.id == item.id) ? 'border: 1.5px solid #275D93;' : 'border: 1.5px solid rgba(0,0,0,.125)'">
                                            <div>
                                                <small class="text-muted mx-2" style="font-weight: 500; font-size: 10px;">
                                                    {{ item.product_detail.product.product_category.current_name }}
                                                </small>
                                                <hr class="mt-1 mb-0">
                                            </div>
                                            <div class="card-body p-2">
                                                <div class="w-100 d-flex justify-content-center align-items-center"
                                                    style="height: 40px;">
                                                    <img :src="item.product_detail.product.image_url" class="img-fluid"
                                                        style="width: auto; height: 40px;">
                                                </div>
                                                <div
                                                    class="w-100 d-flex flex-column justify-content-center align-items-start">
                                                    <small class="mt-1 w-100"
                                                        style="font-weight: 500; font-size: 12px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: start;">
                                                        {{ item.product_detail.product.current_name }}
                                                    </small>
                                                    <small v-if="item.original_price <= item.price" class="text-main"
                                                        style="font-weight: 500; font-size: 12px;">
                                                        {{ item.original_price_formatted }}
                                                    </small>
                                                    <small v-if="item.original_price > item.price" class="text-secondary"
                                                        style="font-weight: 500; font-size: 9px; text-decoration: line-through;">
                                                        {{ item.original_price_formatted }}
                                                    </small>
                                                    <small v-if="item.original_price > item.price" class="text-main mb-1"
                                                        style="font-weight: 500; font-size: 12px;">
                                                        {{ item.price_formatted }}
                                                    </small>
                                                    <div v-if="item.product_detail.type != 'onetime'"
                                                        class="badge badge-outline badge-main mt-1"
                                                        style="font-weight: 500; font-size: 10px;">
                                                        {{ item.product_detail.current_name }}
                                                    </div>
                                                    <div v-if="item.is_recommended"
                                                        class="badge-custom badge-outlined badge-warning mt-1"
                                                        style="font-weight: 500; font-size: 10px;">
                                                        {{ $t('Recommended') }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div id="modal-footer" class="w-100 d-flex flex-column card-footer p-2"
                                                style="align-self: flex-end;">
                                                <span v-if="selected_product_addons.find(addon => addon.id == item.id)"
                                                    class="badge badge-outline badge-danger ml-auto p-1"
                                                    style="font-weight: 500; font-size: 10px; cursor: pointer; height: 19.5px;"
                                                    @click.prevent="removeAddonFromCart(item)">
                                                    {{ $t('Remove') }}
                                                </span>
                                                <span v-else class="badge badge-main ml-auto p-1"
                                                    style="font-weight: 500; font-size: 10px; cursor: pointer; height: 19.5px;"
                                                    @click.prevent="selectAddon(item)">
                                                    + {{ $t('Add') }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="modal-price" class="flex-column"
                        :style="selected_product_addons.length > 0 ? 'display: flex; transition: 0.5s;' : 'display: none; transition: 0.5s;'">
                        <div class="w-100 d-flex justify-content-center align-items-center">
                            <div class="d-flex align-items-center mt-1"
                                style="border-radius: 6px 6px 0px 0px; border: 2px solid rgba(0,0,0,.125); border-bottom: none; padding: 5px 15px; width: 80%;">
                                <span class="badge badge-outline badge-main p-1 mt-1"
                                    style="font-weight: 500; height: 19.5px;">
                                    + {{ selected_product_addons.length }} {{ selected_product_addons.length > 1 ?
                                        $t('Bundles') : $t('Bundle') }}
                                </span>
                                <div class="ml-auto">
                                    <small class="text-main" style="font-weight: 700; font-size: 15px;">
                                        {{ addon_price_formatted }}
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="modal-footer" class="w-100 d-flex flex-column card-footer">
                        <div class="w-100 d-flex justify-content-end align-items-center">
                            <div class="d-flex flex-column">
                                <small style="font-weight: 700;">
                                    {{ $t('Total') }}
                                </small>
                                <small class="text-main" style="font-weight: 700; font-size: 15px;">
                                    {{ total_price_formatted }}
                                </small>
                            </div>
                            <div class="ml-auto">
                                <button class="btn btn-sm btn-main" @click.prevent="updateCart()"
                                    style="border-radius: 10px; width: 100px;">
                                    {{ $t('Update') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else class="px-4 py-3">
                    <label class="text-main font-weight-bold">{{ $t('Please select a product first!') }}</label>
                </div>
            </div>
        </vue-bottom-sheet>
        <vue-bottom-sheet ref="modalAddonDetail" :swipeable="false" :rounded="true" max-height="80vh">
            <div id="modal-main-addon" style="height: 80vh; max-height: 80vh;">
                <div v-if="product_addon">
                    <div id="modal-body-addon">
                        <div style="overflow-y: auto; height: 100%;">
                            <div style="overflow-y: auto; height: 100%;">
                                <div class="w-100 d-flex justify-content-center align-items-center">
                                    <div class="d-flex align-items-center"
                                        style="border-radius: 0px 0px 6px 6px; border: 2px solid rgba(0,0,0,.125); border-top: none; padding: 5px 15px;">
                                        <div class="rounded-circle bg-white d-flex justify-content-center align-items-center mr-2"
                                            style="min-width: 22px; min-height: 22px; border: 1px solid #275D93; padding: 2px;">
                                            <img :src="product_addon.product_detail.product.provider.image_url"
                                                class="img-fluid" style="width: 22px; height: auto; max-height: 22px;" />
                                        </div>
                                        <div class="d-flex flex-column">
                                            <small class="text-muted" style="font-weight: 500; font-size: 9px;">
                                                {{ $t('Product by') }}
                                            </small>
                                            <small style="font-weight: 500; font-size: 10px;">
                                                {{ product_addon.product_detail.product.provider.name }}
                                            </small>
                                        </div>
                                    </div>
                                </div>
                                <div class="w-100 d-flex flex-column justify-content-start align-items-start px-4 py-3">
                                    <small style="font-weight: 600; font-size: 10px;">{{
                                        product_addon.product_detail.product.product_category.current_name
                                    }}</small>
                                    <small style="font-weight: 600; font-size: 15px;">{{
                                        product_addon.product_detail.product.current_name
                                    }}</small>
                                    <small v-if="product_addon.original_price <= product_addon.price" class="text-main"
                                        style="font-weight: 500; font-size: 15px;">
                                        {{ product_addon.original_price_formatted }}
                                    </small>
                                    <small v-if="product_addon.original_price > product_addon.price"
                                        class="text-secondary mt-1"
                                        style="font-weight: 500; font-size: 10px; text-decoration: line-through;">
                                        {{ product_addon.original_price_formatted }}
                                    </small>
                                    <small v-if="product_addon.original_price > product_addon.price" class="text-main mb-1"
                                        style="font-weight: 500; font-size: 15px;">
                                        {{ product_addon.price_formatted }}
                                    </small>
                                    <div>
                                        <div v-if="product_addon.product_detail.type != 'onetime'" class="badge badge-main">
                                            {{ product_addon.product_detail.current_name }}
                                        </div>
                                    </div>
                                    <small class="mt-4" style="font-weight: 500;">
                                        {{ $t('Description') }}
                                    </small>
                                    <small style="font-size: 12px;">
                                        {{ product_addon.product_detail.product.current_description ?? '-' }}
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="modal-footer-addon" class="w-100 d-flex flex-column card-footer">
                        <div class="w-100 d-flex justify-content-end align-items-center">
                            <div class="d-flex flex-column">
                                <small style="font-weight: 700;">
                                    {{ $t('Total') }}
                                </small>
                                <small class="text-main" style="font-weight: 700; font-size: 15px;">
                                    {{ product_addon.price_formatted }}
                                </small>
                            </div>
                            <div class="ml-auto">
                                <button class="btn btn-sm btn-main" @click.prevent="addAddonToCart()"
                                    style="border-radius: 10px; width: 100px;">
                                    + {{ $t('Add') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </vue-bottom-sheet>
    </ContainerLayout>
</template>
  
<script>
import ContainerLayout from "../ContainerLayout.vue";
import CartService from "@/services/cart.service";
import ProductService from "@/services/product.service";
import { VueBottomSheet } from "@webzlodimir/vue-bottom-sheet";
import "@webzlodimir/vue-bottom-sheet/dist/style.css";
import { ref } from "vue";

export default {
    name: "CartList",
    components: {
        ContainerLayout,
        VueBottomSheet,
    },
    data() {
        return {
            loaded_data: false,
            loading: false,
            carts: [],
            checkboxAllByBranch: {},
            selectedItems: {},
            first_load: false,
            modal_cart: null,
            product: null,
            selected_product_detail: null,
            product_addon: null,
            selected_product_addons: [],
            first_load_product: false,
            first_load_addon: false,
            showed_addon_price: false,
        };
    },
    setup() {
        const modalDetail = ref(null);
        const openModalDetail = () => {
            modalDetail.value.open();
        };
        const closeModalDetail = () => {
            modalDetail.value.close();
        };

        const modalAddonDetail = ref(null);
        const openModalAddonDetail = () => {
            modalAddonDetail.value.open();
        };
        const closeModalAddonDetail = () => {
            modalAddonDetail.value.close();
        };

        return {
            modalDetail,
            openModalDetail,
            closeModalDetail,
            modalAddonDetail,
            openModalAddonDetail,
            closeModalAddonDetail,
        };
    },
    computed: {
        currentUser() {
            return localStorage.getItem('loggedData') ? JSON.parse(localStorage.getItem('loggedData')).user : null;
        },

        addon_price_formatted() {
            let total = 0;
            this.selected_product_addons.forEach((addon) => {
                total += parseFloat(addon.price);
            });
            let formatter = new Intl.NumberFormat("id-ID", {
                style: "currency",
                currency: "IDR",
            });
            let total_string = formatter.format(total);
            if (total_string.includes(",00")) {
                total_string = total_string.replace(",00", "");
            }
            return total_string;
        },

        total_price_formatted() {
            let total = 0;
            if (this.selected_product_detail) {
                total += parseFloat(this.selected_product_detail.price);
            }
            this.selected_product_addons.forEach((addon) => {
                total += parseFloat(addon.price);
            });
            let formatter = new Intl.NumberFormat("id-ID", {
                style: "currency",
                currency: "IDR",
            });
            let total_string = formatter.format(total);
            if (total_string.includes(",00")) {
                total_string = total_string.replace(",00", "");
            }
            return total_string;
        },

        selectedCarts() {
            const selected = [];
            for (const branchId in this.carts) {
                for (const item of this.carts[branchId].grouped_carts) {
                    if (this.selectedItems[item.id]) {
                        selected.push(item);
                    }
                }
            }
            return selected;
        },

        total_selected_price_formatted() {
            let total = 0;
            this.selectedCarts.forEach((cart) => {
                total += parseFloat(cart.total_price);
            });
            let formatter = new Intl.NumberFormat("id-ID", {
                style: "currency",
                currency: "IDR",
            });
            let total_string = formatter.format(total);
            if (total_string.includes(",00")) {
                total_string = total_string.replace(",00", "");
            }
            return total_string;
        },
    },
    created() {
        this.loaded_data = false;
        this.loading = true;
        let loader = this.$loading.show();
        this.loadData(loader);
    },
    methods: {
        goBack() {
            if (this.$route.query.from == 'checkout') {
                this.$router.push('/');
            } else {
                this.navigateBackOrHome();
            }
        },

        loadData(loader) {
            CartService.getByUserId(this.currentUser.id)
                .then((response) => {
                    this.loaded_data = true;
                    this.loading = false;
                    loader.hide();

                    if (response.data.status == "success") {
                        this.carts = response.data.data;
                    } else {
                        this.$vueAlert.alert(response.data.message, null, 'error').then(() => {
                            this.goBack();
                        });
                    }
                })
                .catch((error) => {
                    this.loaded_data = true;
                    this.loading = false;
                    loader.hide();

                    let errorMessage = this.$t('An error occurred');
                    if (error.response) {
                        if (error.response.status == 401) {
                            this.$store.dispatch("auth/logout");
                            this.$router.push('/login');
                            return; // Exit the function after handling 401
                        }

                        // Check if the message is available in the error response
                        if (error.response.data && error.response.data.message) {
                            errorMessage = error.response.data.message;
                        } else if (error.response.statusText) {
                            // Fallback to statusText if message is not available
                            errorMessage = error.response.statusText;
                        }
                    } else if (error.message) {
                        // Fallback to error.message if response is not available
                        errorMessage = error.message;
                    }

                    this.$vueAlert.alert(errorMessage, null, 'error').then(() => {
                        this.goBack();
                    });
                });
        },

        remove(id, branchId) {
            this.loading = true;
            let loader = this.$loading.show();
            CartService
                .destroy(id)
                .then((response) => {
                    this.loading = false;
                    if (response.data.status == "success") {
                        this.loadData(loader);
                        this.toggleCheckboxItem(id, branchId);
                    } else {
                        loader.hide();
                        this.$vueAlert.alert(response.data.message, null, 'error');
                    }
                })
                .catch((error) => {
                    this.loaded_data = true;
                    this.loading = false;
                    loader.hide();

                    let errorMessage = this.$t('An error occurred');
                    if (error.response) {
                        if (error.response.status == 401) {
                            this.$store.dispatch("auth/logout");
                            this.$router.push('/login');
                            return; // Exit the function after handling 401
                        }

                        // Check if the message is available in the error response
                        if (error.response.data && error.response.data.message) {
                            errorMessage = error.response.data.message;
                        } else if (error.response.statusText) {
                            // Fallback to statusText if message is not available
                            errorMessage = error.response.statusText;
                        }
                    } else if (error.message) {
                        // Fallback to error.message if response is not available
                        errorMessage = error.message;
                    }

                    this.$vueAlert.alert(errorMessage, null, 'error');
                });
        },



        detail(item) {
            this.loading = true;
            let loader = this.$loading.show();
            ProductService
                .getByProductDetailId(item.product_detail_id)
                .then((response) => {
                    this.loading = false;
                    loader.hide();

                    if (response.data.status == "success") {
                        this.modal_cart = item;
                        this.product = response.data.data;
                        this.selected_product_detail = item.product_detail;
                        this.selected_product_addons = [];
                        item.cart_addons.forEach((cart_addon) => {
                            this.selected_product_addons.push(cart_addon.product_addon);
                        });
                        this.openModalDetail();

                        setTimeout(() => {
                            if (!this.first_load_product) {
                                this.first_load_product = true;

                                let bottomSheetPan = document.getElementsByClassName("bottom-sheet__pan")[0];
                                while (bottomSheetPan.firstChild) {
                                    bottomSheetPan.removeChild(bottomSheetPan.firstChild);
                                }
                                bottomSheetPan.classList.add("d-flex", "align-items-center", "h-auto", "pt-2", "pb-0");

                                let closeButtonWrapper = document.createElement("div");
                                closeButtonWrapper.classList.add("d-flex", "w-100", "px-2", "pb-2");
                                closeButtonWrapper.style.borderBottom = "2px solid #e0e0e0";

                                let closeButton = document.createElement("div");
                                closeButton.classList.add(
                                    "badge-custom",
                                    "badge-outlined",
                                    "badge-dark",
                                );
                                // closeButton.style.position = "absolute";
                                closeButton.style.left = "10px";
                                closeButton.style.top = "10px";
                                closeButton.style.cursor = "pointer";
                                closeButton.style.backgroundColor = "transparent";
                                closeButton.style.border = "none";
                                closeButton.style.fontSize = "22px";
                                closeButton.style.fontWeight = "500";
                                closeButton.innerHTML = 'x';

                                let detailText = document.createElement("span");
                                detailText.innerHTML = this.$t("Product Detail");
                                detailText.style.marginLeft = "10px";
                                detailText.style.fontSize = "16px";
                                detailText.style.fontWeight = "700";

                                // Append the detailText element to closeButton
                                closeButton.appendChild(detailText);
                                closeButton.addEventListener("click", () => {
                                    this.closeModalDetail();
                                });

                                closeButtonWrapper.appendChild(closeButton);
                                bottomSheetPan.appendChild(closeButtonWrapper);

                                let bottomSheetCardHeight = document.getElementsByClassName("bottom-sheet__card")[0].offsetHeight;
                                let bottomSheetPanHeight = document.getElementsByClassName("bottom-sheet__pan")[0].offsetHeight;
                                document.getElementById("modal-main").style.height = (bottomSheetCardHeight - bottomSheetPanHeight) + "px";

                                let modalMainHeight = document.getElementById("modal-main").offsetHeight;
                                // let modalFooterHeight = document.getElementById("modal-footer").offsetHeight;
                                let modalFooterHeight = 68;
                                document.getElementById("modal-body").style.height = (modalMainHeight - modalFooterHeight) + "px";
                            }

                            if (this.selected_product_addons.length > 0) {
                                if (!this.showed_addon_price) {
                                    this.showed_addon_price = true;
                                    let modalBodyHeight = document.getElementById("modal-body").offsetHeight;
                                    document.getElementById("modal-body").style.height = (modalBodyHeight - 40) + "px";
                                }
                            } else {
                                if (this.showed_addon_price) {
                                    this.showed_addon_price = false;
                                    let modalBodyHeight = document.getElementById("modal-body").offsetHeight;
                                    document.getElementById("modal-body").style.height = (modalBodyHeight + 40) + "px";
                                }
                            }
                        }, 10);
                    } else {
                        this.$vueAlert.alert(response.data.message, null, 'error');
                    }
                })
                .catch((error) => {
                    this.loading = false;
                    loader.hide();

                    let errorMessage = this.$t('An error occurred');
                    if (error.response) {
                        if (error.response.status == 401) {
                            this.$store.dispatch("auth/logout");
                            this.$router.push('/login');
                            return; // Exit the function after handling 401
                        }

                        // Check if the message is available in the error response
                        if (error.response.data && error.response.data.message) {
                            errorMessage = error.response.data.message;
                        } else if (error.response.statusText) {
                            // Fallback to statusText if message is not available
                            errorMessage = error.response.statusText;
                        }
                    } else if (error.message) {
                        // Fallback to error.message if response is not available
                        errorMessage = error.message;
                    }

                    this.$vueAlert.alert(errorMessage, null, 'error');
                });
        },

        selectAddon(item) {
            this.product_addon = item;
            this.openModalAddonDetail();

            if (!this.first_load_addon) {
                this.first_load_addon = true;

                setTimeout(() => {
                    let bottomSheetPan = document.getElementsByClassName("bottom-sheet__pan")[1];
                    while (bottomSheetPan.firstChild) {
                        bottomSheetPan.removeChild(bottomSheetPan.firstChild);
                    }
                    bottomSheetPan.classList.add("d-flex", "align-items-center", "h-auto", "pt-2", "pb-0");

                    let closeButtonWrapper = document.createElement("div");
                    closeButtonWrapper.classList.add("d-flex", "w-100", "px-2", "pb-2");
                    closeButtonWrapper.style.borderBottom = "2px solid #e0e0e0";

                    let closeButton = document.createElement("div");
                    closeButton.classList.add(
                        "badge-custom",
                        "badge-outlined",
                        "badge-dark",
                    );
                    // closeButton.style.position = "absolute";
                    closeButton.style.left = "10px";
                    closeButton.style.top = "10px";
                    closeButton.style.cursor = "pointer";
                    closeButton.style.backgroundColor = "transparent";
                    closeButton.style.border = "none";
                    closeButton.style.fontSize = "22px";
                    closeButton.style.fontWeight = "500";
                    closeButton.innerHTML = 'x';

                    let detailText = document.createElement("span");
                    detailText.innerHTML = this.$t("Bundle Detail");
                    detailText.style.marginLeft = "10px";
                    detailText.style.fontSize = "16px";
                    detailText.style.fontWeight = "700";

                    // Append the detailText element to closeButton
                    closeButton.appendChild(detailText);
                    closeButton.addEventListener("click", () => {
                        this.closeModalAddonDetail();
                    });

                    closeButtonWrapper.appendChild(closeButton);
                    bottomSheetPan.appendChild(closeButtonWrapper);

                    let bottomSheetCardHeight = document.getElementsByClassName("bottom-sheet__card")[1].offsetHeight;
                    let bottomSheetPanHeight = document.getElementsByClassName("bottom-sheet__pan")[1].offsetHeight;
                    document.getElementById("modal-main-addon").style.height = (bottomSheetCardHeight - bottomSheetPanHeight) + "px";

                    let modalMainHeight = document.getElementById("modal-main-addon").offsetHeight;
                    // let modalFooterHeight = document.getElementById("modal-footer").offsetHeight;
                    let modalFooterHeight = 68;
                    document.getElementById("modal-body-addon").style.height = (modalMainHeight - modalFooterHeight) + "px";
                }, 10);
            }
        },

        selectProductDetail(detail) {
            this.selected_product_detail = detail;
        },

        addAddonToCart() {
            this.selected_product_addons.push(this.product_addon);
            this.closeModalAddonDetail();

            if (this.selected_product_addons.length > 0) {
                if (!this.showed_addon_price) {
                    this.showed_addon_price = true;
                    let modalBodyHeight = document.getElementById("modal-body").offsetHeight;
                    document.getElementById("modal-body").style.height = (modalBodyHeight - 40) + "px";
                }
            }
        },

        removeAddonFromCart(item) {
            let index = this.selected_product_addons.indexOf(item);
            this.selected_product_addons.splice(index, 1);

            if (this.selected_product_addons.length == 0) {
                if (this.showed_addon_price) {
                    this.showed_addon_price = false;
                    let modalBodyHeight = document.getElementById("modal-body").offsetHeight;
                    document.getElementById("modal-body").style.height = (modalBodyHeight + 40) + "px";
                }
            }
        },

        updateCart() {
            this.loading = true;
            let loader = this.$loading.show();

            let product_addon_ids = [];
            this.selected_product_addons.forEach((item) => {
                product_addon_ids.push(item.id);
            });

            this.closeModalDetail();
            let cart = {
                id: this.modal_cart.id,
                user_id: this.currentUser.id,
                product_detail_id: this.selected_product_detail.id,
                quantity: 1,
                product_addon_ids: product_addon_ids,
            };
            CartService
                .update(this.modal_cart.id, cart)
                .then((response) => {
                    this.loading = false;
                    if (response.data.status == "success") {
                        this.loadData(loader);
                        document.activeElement.blur();
                    } else {
                        loader.hide();
                        this.openModalDetail();
                        this.$vueAlert.alert(response.data.message, null, 'error');
                    }
                })
                .catch((error) => {
                    this.loading = false;
                    loader.hide();
                    this.openModalDetail();

                    let errorMessage = this.$t('An error occurred');
                    if (error.response) {
                        if (error.response.status == 401) {
                            this.$store.dispatch("auth/logout");
                            this.$router.push('/login');
                            return; // Exit the function after handling 401
                        }

                        // Check if the message is available in the error response
                        if (error.response.data && error.response.data.message) {
                            errorMessage = error.response.data.message;
                        } else if (error.response.statusText) {
                            // Fallback to statusText if message is not available
                            errorMessage = error.response.statusText;
                        }
                    } else if (error.message) {
                        // Fallback to error.message if response is not available
                        errorMessage = error.message;
                    }

                    this.$vueAlert.alert(errorMessage, null, 'error');
                });
        },

        toggleCheckboxBranch(branchId) {
            const cartItems = this.carts[branchId].grouped_carts;

            if (this.checkboxAllByBranch[branchId]) {
                // Deselect all items in the branch
                cartItems.forEach((item) => {
                    this.selectedItems[item.id] = false;
                });
                this.checkboxAllByBranch[branchId] = false;
            } else {
                // First, deselect items from all other branches
                for (const otherBranchId in this.carts) {
                    if (otherBranchId != branchId) {
                        this.carts[otherBranchId].grouped_carts.forEach((otherItem) => {
                            this.selectedItems[otherItem.id] = false;
                        });
                        this.checkboxAllByBranch[otherBranchId] = false;
                    }
                }
                // Now, select all items in the Current Destination
                cartItems.forEach((item) => {
                    this.selectedItems[item.id] = true;
                });
                this.checkboxAllByBranch[branchId] = true;
            }
        },

        toggleCheckboxItem(item, branchId) {
            // If trying to select an item
            let isSelected = true;
            if (!this.selectedItems[item.id]) {
                // Check if items from other branches are selected
                for (const otherBranchId in this.carts) {
                    if (otherBranchId != branchId) {
                        const isAnyItemSelected = this.carts[otherBranchId].grouped_carts.some((otherItem) => this.selectedItems[otherItem.id]);
                        if (isAnyItemSelected) {
                            // If yes, show an alert and don't change the selection
                            this.$vueAlert.alert(this.$t("Please select items with the same destination!"), null, 'error');
                            isSelected = false;
                            return;
                        }
                    }
                }
            }

            if (isSelected) {
                // Toggle the item's selected state
                this.selectedItems[item.id] = !this.selectedItems[item.id];
            } else {
                // Reset the checkbox to its previous value
                this.selectedItems[item.id] = false;
            }

            this.updateCheckboxAllByBranch();
        },

        updateCheckboxAllByBranch() {
            for (const branchId in this.carts) {
                const cartItems = this.carts[branchId].grouped_carts;
                const selectedItemsCount = cartItems.filter((item) => this.selectedItems[item.id]).length;
                this.checkboxAllByBranch[branchId] = selectedItemsCount === cartItems.length;
            }
        },

        goToPayment() {
            const selectedBranches = new Set();

            for (const branchId in this.carts) {
                for (const item of this.carts[branchId].grouped_carts) {
                    if (this.selectedItems[item.id]) {
                        selectedBranches.add(branchId);
                    }
                }
            }

            if (selectedBranches.size > 1) {
                this.$vueAlert.alert(this.$t("Please select items with the same destination!"), null, 'error');
            } else if (selectedBranches.size === 1) {
                let cart_ids = [];
                for (const branchId in this.carts) {
                    for (const item of this.carts[branchId].grouped_carts) {
                        if (this.selectedItems[item.id]) {
                            cart_ids.push(item.id);
                        }
                    }
                }
                let encrypted = this.$encryptString(JSON.stringify(cart_ids), 'encryptKey');
                this.$router.push({
                    name: "Purchase Detail",
                    query: {
                        data: encrypted,
                        from: 'cart',
                    },
                });
            } else {
                this.$vueAlert.alert(this.$t('Please select at least one item!'), null, 'error');
            }
        },
    }
};
</script>

<style scoped>
.fake-checkbox {
    display: inline-block;
    cursor: pointer;
    margin-right: 12px;
}

.full-hr {
    margin-left: -20px;
    margin-right: -20px;
}

.full-hr.inside-row {
    margin-left: -20px;
    margin-right: -20px;
}

@media (min-width: 768px) {
    .full-hr {
        margin-left: -28px;
        margin-right: -28px;
    }

    .full-hr.inside-row {
        margin-left: -36px;
        margin-right: -36px;
    }
}

.skeleton-location {
    width: 280px;
    height: 32px;
    background-color: #e6e6e6;
    border-radius: 5px;
}

.skeleton-card {
    width: 100%;
    height: 177.17px;
    background-color: #e6e6e6;
    border-radius: 5px;
}
</style>